import css from "../../css/agents/agents.module.css";

import React from "react";
import PropTypes from "prop-types";
import Avatar from "./Avatar";
import Link from "next/link";
import phoneLinkFormatter from "../../helper/phoneLinkFormatter";
import AgentRating from "../common/AgentRating";
import { THUMB_150_150 } from "../../service/photo";

import SealIcon from "mdi-react/SealIcon";
import BullhornOutlineIcon from "mdi-react/BullhornOutlineIcon";
import EnvelopeIcon from "../../static/icons/envelope2.svg";
import HeartOutlineIcon from "../../static/icons/heart-outline.svg";
import PhoneIcon from "../../static/icons/phone.svg";
import ShareIcon from "../../static/icons/share.svg";
import useMobile from "../../hooks/useMobile";

const Agent = (props) => {
    const isMobile = useMobile();
    const { agent } = props;
    const { agent_locations, is_featured } = agent;

    const soldListings = agent.hlc - agent.clc;

    return (
        <div className={css.agent}>
            <div className={css.photo}>
                {is_featured && <SealIcon className={css.featuredIcon} />}
                <Link
                    href={`/agent?agent=${agent.url}`}
                    as={`/real_estate_agent/${agent.url}`}
                >
                    <Avatar photo={agent.photo} size={THUMB_150_150} />
                </Link>
                <Link
                    href={`/agent?agent=${agent.url}`}
                    as={`/real_estate_agent/${agent.url}`}
                    className={css.profileButton}
                >
                    View Profile
                </Link>
            </div>
            <div className={css.basicInfo}>
                <div className={css.basicInfoHeader}>
                    <h2 className={css.name}>
                        <Link
                            href={`/agent?agent=${agent.url}`}
                            as={`/real_estate_agent/${agent.url}`}
                        >
                            {agent.full_name}
                        </Link>
                    </h2>
                    <div className={css.like}>
                        <a href="#">
                            <HeartOutlineIcon /> 0
                        </a>
                    </div>
                    <div className={css.share}>
                        <a href="#">
                            <ShareIcon />
                        </a>
                    </div>
                    {is_featured && (
                        <div className={css.featuredBadge}>
                            <BullhornOutlineIcon />{" "}
                            <span>Featured Profile</span>
                        </div>
                    )}
                </div>
                {agent.office_name && (
                    <div className={css.company}>{agent.office_name}</div>
                )}
                <div className={css.email}>
                    <EnvelopeIcon /> {agent.email}
                </div>
                {agent.phone_primary && (
                    <div className={css.phone}>
                        {isMobile && (
                            <a href={phoneLinkFormatter(agent.phone_primary)}>
                                <PhoneIcon /> {agent.phone_primary}
                            </a>
                        )}
                        {!isMobile && (
                            <>
                                <PhoneIcon /> {agent.phone_primary}
                            </>
                        )}
                    </div>
                )}
                <div className={css.rating}>
                    <AgentRating rating={agent.rating} />
                </div>
            </div>
            <div className={css.details}>
                {(agent.clc > 0 || agent.hlc > 0 || agent.experience > 0) && (
                    <div className={css.params}>
                        <div className={css.param}>
                            <div className={css.paramTitle}>Listings</div>
                            <div className={css.paramValue}>{agent.clc}</div>
                        </div>
                        {soldListings > 0 ? (
                            <div className={css.param}>
                                <div className={css.paramTitle}>Sold</div>
                                <div className={css.paramValue}>
                                    {soldListings}
                                </div>
                            </div>
                        ) : null}
                        {agent.experience && (
                            <div className={css.param}>
                                <div className={css.paramTitle}>Experience</div>
                                <div className={css.paramValue}>
                                    {agent.experience}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {agent_locations && agent_locations.length > 0 && (
                    <div className={css.areas}>
                        <div className={css.areasTitle}>Areas Served</div>
                        {agent_locations.map((location, index) => (
                            <div className={css.area} key={index}>
                                {location.location.name_with_state}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

Agent.propTypes = {
    agent: PropTypes.object.isRequired,
};

export default Agent;
